import React, { useEffect, useState } from "react";
import styles from "./EventInfoAlert.module.css";
import { IconButton, Modal } from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import { useTranslation } from "react-i18next";
import CloseIcon from "@material-ui/icons/Close";
import moment from "moment";
import "moment/locale/it";

moment.locale("it");
const MAX_TEXT_LENGTH = 190;

const EventInfoAlert = ({ eventData, setEventData, museum }) => {
  const { t } = useTranslation();

  const [descriptionToShow, setDescriptionToShow] = useState(
    eventData?.descrizione_evento?.substring(0, MAX_TEXT_LENGTH)
  );

  const [showMoreActive, setShowMoreActive] = useState(false);

  useEffect(() => {
    if (eventData?.descrizione_evento) {
      setDescriptionToShow(
        eventData?.descrizione_evento?.substring(0, MAX_TEXT_LENGTH)
      );
    }
  }, [eventData]);

  const onShowMorePress = () => {
    setShowMoreActive(true);
    setDescriptionToShow(eventData?.descrizione_evento);
  };

  const onShowLessPress = () => {
    setShowMoreActive(false);
    setDescriptionToShow(
      eventData?.descrizione_evento?.substring(0, MAX_TEXT_LENGTH)
    );
  };

  const handleClose = () => setEventData(null);

  return (
    <Modal open={!!eventData} onClose={handleClose}>
      <div
        className={styles.container}
        style={{ backgroundColor: "white", padding: 20 }}
      >
        <div className={styles.exitButtonContainer}>
          <div className={styles.exitButton}>
            <IconButton className={styles.iconExit} onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          </div>

          <img
            style={{ height: 200, objectFit: "cover" }}
            src={
              eventData?.immagine_evento && eventData?.immagine_evento?.url
                ? eventData?.immagine_evento?.url
                : museum?.cover?.url
            }
            alt=""
          />
        </div>

        <h2 className={styles.eventTitle}>{eventData?.nome_evento}</h2>

        <div className={styles.eventInfo}>
          <h3>{t("date")}</h3>
          <p>
            {moment(eventData?.ora_inizio).format("DD MMM YYYY") ===
            moment(eventData?.ora_fine).format("DD MMM YYYY")
              ? moment(eventData?.ora_inizio).format("DD MMM YYYY")
              : moment(eventData?.ora_inizio).format("DD MMM YYYY") +
                " - " +
                moment(eventData?.ora_fine).format("DD MMM YYYY")}
          </p>
        </div>

        <div className={styles.eventInfo}>
          <h3>{t("time")}</h3>
          <p>
            {moment(eventData?.ora_inizio).format("HH:mm") +
              " - " +
              moment(eventData?.ora_fine).format("HH:mm")}
          </p>
        </div>
        <div className={styles.eventInfo}>
          {/*<Icon
    key="place"
    aria-label="Place"
    color="inherit"
    style={{ marginRight: "8px" }}
  >
    <Place />
  </Icon>*/}
          <h3>{t("location")}</h3>
          <p>{eventData?.luogo_evento}</p>
        </div>

        <div className={styles.eventInfoColumn}>
          <h3>{t("information")}</h3>
          <p>
            {descriptionToShow}
            {descriptionToShow?.length <
              eventData?.descrizione_evento?.length && " ..."}
          </p>
          {/*<h2>{eventData?.nome_evento}</h2>

        <div className={styles.placeContainer}>
          <Icon
            key="place"
            aria-label="Place"
            color="inherit"
            style={{ marginRight: "8px" }}
          >
            <Place />
          </Icon>
          <p>{eventData?.luogo_evento}</p>
        </div>
        <div className={styles.infoContainer}>
          <h3>{t("information")}</h3>
          <p>
            {descriptionToShow}
            {descriptionToShow?.length <
              eventData?.descrizione_evento?.length && " ..."}
            </p>*/}

          {descriptionToShow?.length < eventData?.descrizione_evento?.length &&
            !showMoreActive && (
              <div className={styles.showMore} onClick={onShowMorePress}>
                <ExpandMoreIcon />
                <p>{t("readMore")}</p>
              </div>
            )}

          {showMoreActive && (
            <div className={styles.showMore} onClick={onShowLessPress}>
              <ExpandLessIcon />
              <p>{t("readLess")}</p>
            </div>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default EventInfoAlert;
